import React from 'react';
import KPICard from '../../components/shared/KPICard';
import StatusPill from '../../components/shared/StatusPill';
import SectionDivider from '../../components/shared/SectionDivider';
import GujaratMap from './GujaratMap';
import { gujaratStateKPIs, gujaratDistricts } from '../../data/mockData';

export default function StateOverview() {
  return (
    <div className="p-6 space-y-6">
      {/* KPI row — 6 cards */}
      <div className="flex gap-4">
        <KPICard title="Total Plants"          value={gujaratStateKPIs.plants.toLocaleString()}  subtext="Across 33 districts" />
        <KPICard title="Installed Capacity"    value={`${gujaratStateKPIs.capacityGWp} GWp`}     subtext="Installed" />
        <KPICard title="Today's Generation"    value={`${gujaratStateKPIs.generationGWh} GWh`}   subtext="+3.2% vs yesterday" subtextColor="green" />
        <KPICard title="Active Plants"         value={`${gujaratStateKPIs.activePercent}%`}       subtext="5,678 of 6,240" subtextColor="green" />
        <KPICard title="Offline / Fault"       value={gujaratStateKPIs.offlineFaultCount.toLocaleString()} subtext="9% needs review" subtextColor="red" bgColor="bg-red-50" />
        <KPICard title="Avg Performance Ratio" value="78.2%"                                      subtext="Gujarat — Good zone" subtextColor="green" />
      </div>

      {/* Map + District table */}
      <div className="flex gap-4">
        {/* Gujarat district heatmap */}
        <div className="w-[55%] bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider
            title="Gujarat District Map"
            subtitle="Generation heatmap — hover for details"
          />
          <div style={{ height: 360 }}>
            <GujaratMap />
          </div>
        </div>

        {/* District summary table */}
        <div className="flex-1 bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="District Summary" subtitle="Today" />
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-border">
                <th className="text-left py-2 text-text-tertiary font-medium">District</th>
                <th className="text-right py-2 text-text-tertiary font-medium">Plants</th>
                <th className="text-right py-2 text-text-tertiary font-medium">GWh</th>
                <th className="text-right py-2 text-text-tertiary font-medium">PR%</th>
                <th className="text-center py-2 text-text-tertiary font-medium">Status</th>
              </tr>
            </thead>
            <tbody>
              {gujaratDistricts.map(d => (
                <tr key={d.id} className="border-b border-border/50 hover:bg-bg-secondary cursor-pointer">
                  <td className="py-2.5 font-medium text-text-primary">{d.name}</td>
                  <td className="py-2.5 text-right text-text-secondary">{d.plants.toLocaleString()}</td>
                  <td className="py-2.5 text-right font-medium text-text-primary">{d.generationGWh.toFixed(2)}</td>
                  <td className={`py-2.5 text-right font-semibold ${d.prPercent >= 75 ? 'text-success' : 'text-warning'}`}>
                    {d.prPercent.toFixed(1)}%
                  </td>
                  <td className="py-2.5 text-center">
                    <StatusPill status={d.status} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Secondary KPI row */}
      <div className="flex gap-4">
        <div className="bg-white rounded-card border border-border shadow-card p-4 flex-1">
          <p className="text-xs text-text-tertiary font-medium uppercase tracking-wide">Avg CUF Today</p>
          <p className="text-xl font-bold text-text-primary mt-1">{gujaratStateKPIs.avgCufPct}%</p>
          <p className="text-xs text-text-secondary mt-1">Peak 10am–3pm</p>
        </div>
        <div className="bg-white rounded-card border border-border shadow-card p-4 flex-1">
          <p className="text-xs text-text-tertiary font-medium uppercase tracking-wide">CO₂ Offset Lifetime</p>
          <p className="text-xl font-bold text-teal mt-1">{gujaratStateKPIs.co2OffsetMT} MT</p>
          <p className="text-xs text-text-secondary mt-1">Est. × 0.71 kg/kWh</p>
        </div>
        <div className="bg-white rounded-card border border-border shadow-card p-4 flex-1">
          <p className="text-xs text-text-tertiary font-medium uppercase tracking-wide">State Avg PR</p>
          <p className="text-xl font-bold text-success mt-1">78.2%</p>
          <p className="text-xs text-text-secondary mt-1">Gujarat average</p>
        </div>
      </div>
    </div>
  );
}
